(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["h2o-complete-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseBoolean = (value) => value === true || value === 'true';

    const initialiseSystem = (section) => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';

      const items = Array.from(section.querySelectorAll('[data-h2o-system-item]'));
      const linkedCards = Array.from(section.querySelectorAll('[data-h2o-system-link-card]'));
      const relatedChecks = Array.from(section.querySelectorAll('[data-h2o-system-check]'));
      const countOutput = section.querySelector('[data-h2o-system-count]');
      const totalOutput = section.querySelector('[data-h2o-system-total]');
      const addButton = section.querySelector('[data-h2o-system-add]');
      const addLabel = section.querySelector('[data-h2o-system-add-label]');
      const errorOutput = section.querySelector('[data-h2o-system-error]');
      const labelSource = section.querySelector('[data-add-pending-label]');
      const variantsSource = section.querySelector('[data-h2o-current-variants]');
      const moneyFormat = section.dataset.moneyFormat;
      const currency = section.dataset.currency || 'AUD';
      const originalAddLabel = addLabel?.textContent || '';
      let currentVariants = [];

      try {
        currentVariants = JSON.parse(variantsSource?.textContent || '[]');
      } catch (error) {
        currentVariants = [];
      }

      const formatMoney = (cents) => {
        if (window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }

        return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
          style: 'currency',
          currency
        }).format(cents / 100);
      };

      const getMainVariantInput = () =>
        document.querySelector('product-form form [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');

      const getCurrentVariant = () => {
        const selectedId = getMainVariantInput()?.value;
        return (
          currentVariants.find((variant) => String(variant.id) === String(selectedId)) ||
          currentVariants.find((variant) => parseBoolean(variant.available)) ||
          currentVariants[0]
        );
      };

      const getRelatedVariant = (item) => {
        const control = item.querySelector('[data-h2o-system-variant]');
        if (!control) return null;

        if (control.tagName === 'SELECT') {
          const option = control.options[control.selectedIndex];
          if (!option) return null;

          return {
            id: option.value,
            price: Number(option.dataset.price || 0),
            available: parseBoolean(option.dataset.available)
          };
        }

        return {
          id: control.value,
          price: Number(control.dataset.price || 0),
          available: parseBoolean(control.dataset.available)
        };
      };

      const updateRelatedCard = (item) => {
        if (item.hasAttribute('data-current-product')) return;
        const variant = getRelatedVariant(item);
        const price = item.querySelector('[data-h2o-system-price]');
        const stock = item.querySelector('[data-h2o-system-stock]');
        const check = item.querySelector('[data-h2o-system-check]');

        if (price && variant) price.textContent = formatMoney(variant.price);
        if (stock && variant) {
          stock.textContent = variant.available
            ? section.dataset.inStockLabel
            : section.dataset.unavailableLabel;
          stock.classList.toggle('h2o-system__stock--unavailable', !variant.available);
        }
        if (check && variant) {
          check.disabled = !variant.available;
          if (!variant.available) check.checked = false;
        }
      };

      const getSelectedItems = () => {
        const selectedItems = [];
        const currentVariant = getCurrentVariant();

        if (currentVariant && parseBoolean(currentVariant.available)) {
          selectedItems.push({
            id: String(currentVariant.id),
            quantity: 1,
            price: Number(currentVariant.price || 0)
          });
        }

        items.forEach((item) => {
          if (item.hasAttribute('data-current-product')) return;
          const check = item.querySelector('[data-h2o-system-check]');
          if (!check?.checked || check.disabled) return;

          const variant = getRelatedVariant(item);
          if (!variant?.available) return;

          selectedItems.push({
            id: String(variant.id),
            quantity: 1,
            price: variant.price
          });
        });

        return selectedItems;
      };

      const updateSummary = () => {
        items.forEach(updateRelatedCard);

        const currentVariant = getCurrentVariant();
        const currentItem = section.querySelector('[data-current-product]');
        const currentPrice = currentItem?.querySelector('[data-h2o-system-price]');
        const currentStock = currentItem?.querySelector('[data-h2o-system-stock]');

        if (currentPrice && currentVariant) {
          currentPrice.textContent = formatMoney(Number(currentVariant.price || 0));
        }
        if (currentStock && currentVariant) {
          const currentAvailable = parseBoolean(currentVariant.available);
          currentStock.textContent = currentAvailable
            ? section.dataset.inStockLabel
            : section.dataset.unavailableLabel;
          currentStock.classList.toggle('h2o-system__stock--unavailable', !currentAvailable);
        }

        const selectedItems = getSelectedItems();
        const total = selectedItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const itemLabel =
          selectedItems.length === 1 ? section.dataset.itemSingular : section.dataset.itemPlural;

        if (countOutput) countOutput.textContent = `${selectedItems.length} ${itemLabel}`;
        if (totalOutput) totalOutput.textContent = formatMoney(total);
        if (addButton) addButton.disabled = selectedItems.length === 0;
      };

      const addSystem = async () => {
        const selectedItems = getSelectedItems();
        if (selectedItems.length === 0) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = labelSource?.dataset.addPendingLabel || originalAddLabel;
        if (errorOutput) {
          errorOutput.hidden = true;
          errorOutput.textContent = '';
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: selectedItems.map((item) => ({
                id: Number(item.id),
                quantity: item.quantity
              }))
            })
          });

          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (error) {
          addButton.disabled = false;
          addButton.removeAttribute('aria-busy');
          if (addLabel) addLabel.textContent = originalAddLabel;
          if (errorOutput) {
            errorOutput.textContent =
              labelSource?.dataset.addErrorLabel || 'Unable to add the selected products.';
            errorOutput.hidden = false;
          }
        }
      };

      linkedCards.forEach((card) => {
        card.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target || event.defaultPrevented || event.button !== 0) return;
          if (
            target.closest(
              'a, button, input, select, textarea, .h2o-system__selection, .h2o-system__variant, .quantity, [data-h2o-system-quantity]'
            )
          ) {
            return;
          }

          const url = card.dataset.productUrl;
          if (url) window.location.assign(url);
        });
      });

      relatedChecks.forEach((check) => check.addEventListener('change', updateSummary));
      section.querySelectorAll('select[data-h2o-system-variant]').forEach((select) => {
        select.addEventListener('change', updateSummary);
      });
      addButton?.addEventListener('click', addSystem);

      document.addEventListener('change', (event) => {
        if (!event.target.closest('product-form, variant-selects, variant-radios')) return;
        window.requestAnimationFrame(() => window.requestAnimationFrame(updateSummary));
      });

      ['variant:change', 'variantChange', 'product:variant-change'].forEach((eventName) => {
        document.addEventListener(eventName, updateSummary);
      });

      updateSummary();
    };

    const initialiseSystems = (root = document) => {
      root.querySelectorAll('[data-h2o-system]').forEach(initialiseSystem);
    };

    initialiseSystems();
    document.addEventListener('shopify:section:load', (event) => initialiseSystems(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2o-material-estimator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseBoolean = (value) => value === true || value === 'true';

    const formatNumber = (value, maximumFractionDigits = 1) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        minimumFractionDigits: 0,
        maximumFractionDigits
      }).format(value);

    const initialiseLinearFilletEstimator = (section) => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';

      const mortarConsumptionRate = Number(section.dataset.mortarConsumptionRate);
      const packageWeight = Number(section.dataset.packageWeight);
      const defaultFilletSize = Number(section.dataset.defaultFilletSize);
      const unitDescription = section.dataset.unitDescription;
      const presets = Array.from(section.querySelectorAll('[data-h2o-estimator-fillet-preset]'));
      const customFields = section.querySelector('[data-h2o-estimator-custom-fields]');
      const widthInput = section.querySelector('[data-h2o-estimator-fillet-width]');
      const heightInput = section.querySelector('[data-h2o-estimator-fillet-height]');
      const lengthInput = section.querySelector('[data-h2o-estimator-length]');
      const wasteInput = section.querySelector('[data-h2o-estimator-fillet-waste]');
      const coverageOutput = section.querySelector('[data-h2o-estimator-lm-per-bag]');
      const bagsOutput = section.querySelector('[data-h2o-estimator-bags]');
      const summaryOutput = section.querySelector('[data-h2o-estimator-fillet-summary]');

      if (!presets.some((preset) => preset.checked)) {
        const matchingPreset = presets.find((preset) => Number(preset.value) === defaultFilletSize);
        (matchingPreset || presets.find((preset) => preset.value === 'custom'))?.click();
      }

      const getSelectedPreset = () => presets.find((preset) => preset.checked)?.value;

      const getDimensions = () => {
        const selectedPreset = getSelectedPreset();
        if (selectedPreset === 'custom') {
          return {
            width: Number(widthInput?.value),
            height: Number(heightInput?.value)
          };
        }

        const size = Number(selectedPreset);
        return { width: size, height: size };
      };

      const formatDimension = (value) => formatNumber(value, 1);

      const setCustomFieldsVisibility = () => {
        if (!customFields) return;
        customFields.hidden = getSelectedPreset() !== 'custom';
      };

      const calculateCoverage = (width, height, wastePercentage) => {
        const areaMm2 = (width * height) / 2;
        const volumeLitresPerMetre = areaMm2 / 1000;
        const kilogramsPerMetre = volumeLitresPerMetre * (mortarConsumptionRate / 10);
        const adjustedKilogramsPerMetre = kilogramsPerMetre * (1 + wastePercentage / 100);

        return {
          kilogramsPerMetre,
          adjustedLinealMetresPerBag: packageWeight / adjustedKilogramsPerMetre
        };
      };

      const updateQuickReference = () => {
        [30, 35, 40].forEach((size) => {
          const output = section.querySelector(`[data-h2o-estimator-quick-reference="${size}"]`);
          if (!output) return;
          const result = calculateCoverage(size, size, 10);
          output.textContent = `${formatNumber(result.adjustedLinealMetresPerBag, 1)} lm/bag`;
        });
      };

      const updateEstimate = () => {
        setCustomFieldsVisibility();

        const { width, height } = getDimensions();
        const wastePercentage = Number(wasteInput?.value);
        const projectLength = Number(lengthInput?.value);
        const validDimensions =
          Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0;
        const validWaste =
          Number.isFinite(wastePercentage) && wastePercentage >= 0 && wastePercentage <= 20;

        if (!validDimensions || !validWaste) {
          if (coverageOutput) coverageOutput.textContent = '—';
          if (bagsOutput) bagsOutput.textContent = '—';
          if (summaryOutput) summaryOutput.textContent = '';
          return;
        }

        const result = calculateCoverage(width, height, wastePercentage);
        const validLength = Number.isFinite(projectLength) && projectLength > 0;
        const bags = validLength
          ? Math.ceil(
              (projectLength * result.kilogramsPerMetre * (1 + wastePercentage / 100)) /
                packageWeight
            )
          : 0;

        if (coverageOutput) {
          coverageOutput.textContent =
            `Approx. ${formatNumber(result.adjustedLinealMetresPerBag, 1)} lineal metres per ${unitDescription}`;
        }
        if (bagsOutput) {
          bagsOutput.textContent = validLength ? `${bags} × ${unitDescription}` : '—';
        }
        if (summaryOutput) {
          summaryOutput.textContent =
            `Calculated using a ${formatDimension(width)} × ${formatDimension(height)} mm triangular fillet with ${formatNumber(wastePercentage, 1)}% waste.`;
        }
      };

      presets.forEach((preset) => preset.addEventListener('change', updateEstimate));
      [widthInput, heightInput, lengthInput, wasteInput].forEach((input) => {
        input?.addEventListener('input', updateEstimate);
      });

      updateQuickReference();
      updateEstimate();
    };

    const initialiseAreaEstimator = (section) => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';

      const coveragePerUnit = Number(section.dataset.coveragePerUnit);
      const coverageBasis = section.dataset.coverageBasis;
      const recommendedCoats = Number(section.dataset.recommendedCoats);
      const wasteAllowance = Number(section.dataset.wasteAllowance);
      const unitDescription = section.dataset.unitDescription;
      const areaInput = section.querySelector('[data-h2o-estimator-area]');
      const coatsInput = section.querySelector('[data-h2o-estimator-coats]');
      const quantityOutput = section.querySelector('[data-h2o-estimator-quantity]');
      const totalCoverageOutput = section.querySelector('[data-h2o-estimator-total-coverage]');
      const wasteOutput = section.querySelector('[data-h2o-estimator-waste]');
      const addButton = section.querySelector('[data-h2o-estimator-add]');
      const addLabel = section.querySelector('[data-h2o-estimator-add-label]');
      const errorOutput = section.querySelector('[data-h2o-estimator-error]');
      const labelSource = section.querySelector('[data-add-pending-label]');
      const variantsSource = section.querySelector('[data-h2o-estimator-variants]');
      const originalAddLabel = addLabel?.textContent.trim() || '';
      let calculatedQuantity = 0;
      let variants = [];

      try {
        variants = JSON.parse(variantsSource?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const getMainVariantInput = () =>
        document.querySelector('product-form form [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');

      const getCurrentVariant = () => {
        const selectedId = getMainVariantInput()?.value || section.dataset.defaultVariantId;
        return (
          variants.find((variant) => String(variant.id) === String(selectedId)) ||
          variants.find((variant) => parseBoolean(variant.available)) ||
          variants[0]
        );
      };

      const clearError = () => {
        if (!errorOutput) return;
        errorOutput.hidden = true;
        errorOutput.textContent = '';
      };

      const updateEstimate = () => {
        clearError();

        const area = Number(areaInput?.value);
        const coats = Number(coatsInput?.value);
        const currentVariant = getCurrentVariant();
        const validInputs = Number.isFinite(area) && area > 0 && Number.isInteger(coats) && coats > 0;
        const variantAvailable = currentVariant && parseBoolean(currentVariant.available);

        if (!validInputs) {
          calculatedQuantity = 0;
          if (quantityOutput) quantityOutput.textContent = '—';
          if (totalCoverageOutput) totalCoverageOutput.textContent = '—';
          if (wasteOutput) wasteOutput.textContent = '—';
          if (addButton) addButton.disabled = true;
          return;
        }

        const effectiveCoverage =
          coverageBasis === 'per coat'
            ? coveragePerUnit / coats
            : (coveragePerUnit * recommendedCoats) / coats;
        const wasteArea = area * (wasteAllowance / 100);
        const adjustedArea = area + wasteArea;

        calculatedQuantity = Math.ceil(adjustedArea / effectiveCoverage);
        const totalCoverage = calculatedQuantity * effectiveCoverage;

        if (quantityOutput) quantityOutput.textContent = `${calculatedQuantity} × ${unitDescription}`;
        if (totalCoverageOutput) {
          totalCoverageOutput.textContent = `${formatNumber(totalCoverage, 2)} m²`;
        }
        if (wasteOutput) {
          wasteOutput.textContent = `${formatNumber(wasteAllowance, 2)}% (${formatNumber(wasteArea, 2)} m²)`;
        }
        if (addButton) addButton.disabled = !variantAvailable || calculatedQuantity < 1;
      };

      const addEstimatedQuantity = async () => {
        const currentVariant = getCurrentVariant();
        if (!currentVariant || !parseBoolean(currentVariant.available) || calculatedQuantity < 1) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = labelSource?.dataset.addPendingLabel || originalAddLabel;
        clearError();

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: String(currentVariant.id), quantity: calculatedQuantity }]
            })
          });

          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (error) {
          addButton.disabled = false;
          addButton.removeAttribute('aria-busy');
          if (addLabel) addLabel.textContent = originalAddLabel;
          if (errorOutput) {
            errorOutput.textContent =
              labelSource?.dataset.addErrorLabel || 'Unable to add the estimated quantity.';
            errorOutput.hidden = false;
          }
        }
      };

      areaInput?.addEventListener('input', updateEstimate);
      coatsInput?.addEventListener('input', updateEstimate);
      addButton?.addEventListener('click', addEstimatedQuantity);

      document.addEventListener('change', (event) => {
        if (!event.target.closest('product-form, variant-selects, variant-radios')) return;
        window.requestAnimationFrame(() => window.requestAnimationFrame(updateEstimate));
      });

      ['variant:change', 'variantChange', 'product:variant-change'].forEach((eventName) => {
        document.addEventListener(eventName, updateEstimate);
      });

      updateEstimate();
    };

    const initialiseEstimator = (section) => {
      if (section.dataset.calculatorType === 'linear_fillet') {
        initialiseLinearFilletEstimator(section);
        return;
      }

      initialiseAreaEstimator(section);
    };

    const initialiseEstimators = (root = document) => {
      root.querySelectorAll('[data-h2o-estimator]').forEach(initialiseEstimator);
    };

    initialiseEstimators();
    document.addEventListener('shopify:section:load', (event) => initialiseEstimators(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2o-technical-information"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-h2o-calculator]').forEach((calculator) => {
    if (calculator.dataset.initialised === 'true') return;
    calculator.dataset.initialised = 'true';

    const area = calculator.querySelector('[data-h2o-area]');
    const coats = calculator.querySelector('[data-h2o-coats]');
    const waste = calculator.querySelector('[data-h2o-waste]');
    const pack = calculator.querySelector('[data-h2o-pack]');
    const quantity = calculator.querySelector('[data-h2o-quantity]');
    const cartQuantity = calculator.querySelector('[data-h2o-cart-quantity]');
    const variant = calculator.querySelector('[data-h2o-variant]');
    const totalCoverage = calculator.querySelector('[data-h2o-total-coverage]');

    const recalculate = () => {
      const areaValue = Math.max(0, Number.parseFloat(area.value) || 0);
      const coatValue = Math.max(1, Number.parseInt(coats.value, 10) || 1);
      const wasteValue = Math.max(0, Number.parseFloat(waste.value) || 0);
      const selectedPack = pack.options[pack.selectedIndex];
      const coveragePerCoat = Math.max(0, Number.parseFloat(selectedPack?.dataset.coverage) || 0);
      const adjustedArea = areaValue * (1 + wasteValue / 100);
      const requiredQuantity = coveragePerCoat > 0 ? Math.max(1, Math.ceil((adjustedArea * coatValue) / coveragePerCoat)) : 0;
      const suppliedCoverage = coatValue > 0 ? (requiredQuantity * coveragePerCoat) / coatValue : 0;

      quantity.textContent = String(requiredQuantity);
      cartQuantity.value = String(requiredQuantity);
      variant.value = selectedPack?.value || '';
      totalCoverage.textContent = suppliedCoverage > 0 ? `${suppliedCoverage.toFixed(1)} m²` : '';
    };

    [area, coats, waste, pack].forEach((field) => field?.addEventListener('input', recalculate));
    recalculate();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		//if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
